import React from 'react';

import PropTypes from 'prop-types';

import { Carousel } from 'reaxl';

import MediaGalleryImage from './MediaGalleryImage';

function MediaSlider({
    images,
    isSm,
    listingTitle = 'Listing',
    onImageClick,
    onNextButtonClick,
    onPrevButtonClick,
}) {
    const carouselArgs = {
        className: isSm ? 'img-rounded' : 'row', // border-radius or extend to browser edge
        fullWidthScrollXs: true, // enable touch/drag events
        initialIndex: 0,
        onNextButtonClick,
        onPrevButtonClick,
        prevNextButtons: false,
        scrollItemsCount: 0,
        singleImageMode: true,
        visibilityThreshold: 0.9,
    };

    return (
        <Carousel
            {...carouselArgs}
        >
            {images.map((image, index) => (
                <MediaGalleryImage
                    alt={`${listingTitle} image ${index + 1}`}
                    isSlider
                    key={image.src}
                    lazyImage={index < 2 ? 'eager' : 'lazy'}
                    onClick={(e) => onImageClick(e, index)}
                    src={image.src}
                    type="main"
                />
            ))}
        </Carousel>
    );
}

MediaSlider.propTypes = {
    images: PropTypes.arrayOf(
        PropTypes.shape({
            src: PropTypes.string.isRequired,
        })
    ).isRequired,
    isSm: PropTypes.bool,
    listingTitle: PropTypes.string,
    onImageClick: PropTypes.func.isRequired,
    onNextButtonClick: PropTypes.func,
    onPrevButtonClick: PropTypes.func,
};

export default React.memo(MediaSlider);
